function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "#231F20"
}, /*#__PURE__*/React.createElement("path", {
  d: "M23.487 20.8l-4.697-4.7c1.1-1.6 1.799-3.6 1.799-5.8C20.589 4.6 15.99 0 10.294 0 4.597.1 0 4.7 0 10.4 0 16 4.597 20.6 10.294 20.6c2.2 0 4.298-.7 5.897-1.9l4.598 4.6c.4.4.8.5 1.299.5.5 0 .9-.2 1.3-.5.799-.6.799-1.8.1-2.5zM3.698 10.4c0-3.6 2.998-6.6 6.596-6.6s6.597 3 6.597 6.6c0 3.6-2.999 6.6-6.597 6.6-3.698 0-6.596-3-6.596-6.6z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.4 14.9h-.2c-.6 0-1-.5-1-1v-2.3H6.8c-.6 0-1-.5-1-1v-.2c0-.6.5-1 1-1h2.3V6.9c0-.6.5-1 1-1h.2c.6 0 1 .5 1 1v2.3h2.4c.6 0 1 .5 1 1v.2c0 .6-.5 1-1 1h-2.4v2.3c.1.8-.3 1.2-.9 1.2z"
}));

var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _ref);
};

export default SvgComponent;